import femaleInfertilityIcon from "../Img/icon/Reproductive.png";
import maleInfertilityIcon from "../Img/icon/Reproductive.png";
import urologyIcon from "../Img/icon/urology.png";
import gynecologyIcon from "../Img/icon/gynecology.png";
import radiologyIcon from "../Img/icon/ultrasound.png";

export const serviceImages = {
    "female-infertility": {
        icon: femaleInfertilityIcon,
    },
    "male-infertility": {
        icon: maleInfertilityIcon,
    },
    "urology-andrology": {
        icon: urologyIcon,
    },
    gynecology: {
        icon: gynecologyIcon,
    },
    radiology: {
        icon: radiologyIcon,
    },
};
